export function disableAutocomplete() {
  const el = document.getElementsByClassName('ant-select-selection-search-input');
  for (let i = 0; i < el.length; i++) {
    el[i].setAttribute('autocomplete', 'none');
  }
}
